import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categoryData';

interface CategoryTabsProps {
  activeSlug: string;
  onSelect: (slug: string) => void;
}

export default function CategoryTabs({ activeSlug, onSelect }: CategoryTabsProps) {
  return (
    <div className="w-full overflow-x-auto pb-2">
      <div className="flex items-center gap-2 min-w-max">
        {categories.map((cat) => {
          const isActive = activeSlug === cat.slug;
          return (
            <button
              key={cat.slug}
              onClick={() => onSelect(cat.slug)}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-300 ${
                isActive
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
              }`}
            >
              <i className={`${cat.icon} text-sm w-4 h-4 flex items-center justify-center`}></i>
              {cat.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}